import React, { useEffect } from "react";

import {
    About,
    ContactUsLink,
    CurrentUserAvatar,
    HomeLink,
    LogOut,
    OtherResources,
    initJiraWidgetObserver,
} from "@digatex/digatex-ui-lib";
import { Layout, Row, Space, App } from "antd";
import "@/components/navMenu/navMenu.css";

import "antd/dist/antd";
import { Auth } from "@digatex/digatex-ui-lib";

const NavMenu: React.FC = () => {

    useEffect(() => {
        initJiraWidgetObserver();
    }, []);

const { modal } = App.useApp();

    const openJiraWidgetOrReportError = ({ moduleName = "Engineering Hub" }) => {
        const iframeContent = document.querySelector("#jsd-widget")?.contentDocument;
        const button = iframeContent?.querySelector("#help-button");
        const isFormOpen = iframeContent?.querySelector(".help-form") ||
            iframeContent?.querySelector("form");

        if (button && !isFormOpen) {
            button.click();

            const observer = new MutationObserver((_, observerInstance) => {
                const helpForm = iframeContent.querySelector(".help-form");

                if (helpForm) {
                    observerInstance.disconnect();

                    const inputData = [
                        {
                            class: "#email",
                            value: Auth.tokenParsed()?.email || "",
                        },
                        {
                            class: "#customfield_10051",
                            value: process.env.REACT_APP_INSTANCE,
                        },
                        {
                            class: "#customfield_10053",
                            value: moduleName,
                        },
                    ];

                    inputData.forEach(({ class: selector, value }) => {
                        const input = iframeContent.querySelector(selector);
                        if (input) {
                            input.setAttribute("value", value);
                            input.dispatchEvent(new Event("change", { bubbles: true }));
                        }
                    });
                }
            });

            observer.observe(iframeContent.body, { childList: true, subtree: true });

            return;
        }

        if (!button && !isFormOpen) {
            const finalSupportEmail =
                process.env.REACT_APP_SUPPORT_EMAIL ||
                "support@digatex.atlassian.net";

            modal.error({
                title: "Service Unavailable",
                content: (
                    <div>
                        <p>Sorry, we're currently experiencing a temporary issue.</p>
                        <p>
                            Please try again later or contact us at{" "}
                            <a href={`mailto:${finalSupportEmail}`}>{finalSupportEmail}</a>
                        </p>
                    </div>
                ),
                okText: "Close",
            });
        }
    };


    return (
        <div>
            <Layout.Header
                style={{
                    width: "100%",
                    padding: 10,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "var(--spacing-sm)" }}>
                    <HomeLink />
                </div>
                <Row>
                    <Space size={"middle"}>
                        <About />
                        <OtherResources />
                        <ContactUsLink show={openJiraWidgetOrReportError} />
                        <LogOut />
                        <CurrentUserAvatar />
                    </Space>
                </Row>
            </Layout.Header>
        </div>
    );
};

export default NavMenu;
